export default "__VITE_ASSET__DYoSCEqp__"